var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 col-lg-8 order-lg-1" },
    [
      _vm._l(_vm.preparedNotifications, function (notification, key) {
        return _c("notification-alert-block", {
          key: key,
          attrs: {
            notification: notification,
            setnotificationlink: _vm.setnotificationlink,
          },
        })
      }),
      _vm._v(" "),
      _vm.ordertype === "stopped"
        ? [
            _c("ukraine-stopped-order", {
              attrs: {
                lng: _vm.lng,
                mainlng: _vm.mainlng,
                translations: _vm.translations,
                parcel: _vm.parcel,
                orders: _vm.orders,
                paymentmethods: _vm.paymentmethods,
                deliverymethods: _vm.deliverymethods,
                ordertype: _vm.ordertype,
                account: _vm.account,
                locations: _vm.locations,
                savedeliverylink: _vm.savedeliverylink,
                dopaymentlink: _vm.dopaymentlink,
                neworderslink: _vm.neworderslink,
                ordersonwarehoselink: _vm.ordersonwarehoselink,
                sentorderslink: _vm.sentorderslink,
                arrivedorderslink: _vm.arrivedorderslink,
                deliveredorderslink: _vm.deliveredorderslink,
                setnotificationlink: _vm.setnotificationlink,
                upload_files_link: _vm.upload_files_link,
                delete_files_link: _vm.delete_files_link,
                downloadlink: _vm.downloadlink,
                refusebilllink: _vm.refusebilllink,
                confirmorderlink: _vm.confirmorderlink,
              },
            }),
          ]
        : [
            ["new", "on-warehouse"].includes(_vm.ordertype)
              ? _c("new-to-on-warehouse-order", {
                  attrs: {
                    lng: _vm.lng,
                    mainlng: "mainlng",
                    translations: _vm.translations,
                    parcel: _vm.parcel,
                    ordertype: _vm.ordertype,
                    neworderslink: _vm.neworderslink,
                    ordersonwarehoselink: _vm.ordersonwarehoselink,
                    sentorderslink: _vm.sentorderslink,
                    arrivedorderslink: _vm.arrivedorderslink,
                    deliveredorderslink: _vm.deliveredorderslink,
                    upload_files_link: _vm.upload_files_link,
                    delete_files_link: _vm.delete_files_link,
                    downloadlink: _vm.downloadlink,
                    locations: _vm.locations,
                    setnotificationlink: _vm.setnotificationlink,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            ["sent", "arrived", "delivered"].includes(_vm.ordertype)
              ? _c("sent-to-delivered-order", {
                  attrs: {
                    lng: _vm.lng,
                    mainlng: _vm.mainlng,
                    translations: _vm.translations,
                    parcel: _vm.parcel,
                    orders: _vm.orders,
                    paymentmethods: _vm.paymentmethods,
                    deliverymethods: _vm.deliverymethods,
                    ordertype: _vm.ordertype,
                    account: _vm.account,
                    locations: _vm.locations,
                    savedeliverylink: _vm.savedeliverylink,
                    dopaymentlink: _vm.dopaymentlink,
                    neworderslink: _vm.neworderslink,
                    ordersonwarehoselink: _vm.ordersonwarehoselink,
                    sentorderslink: _vm.sentorderslink,
                    arrivedorderslink: _vm.arrivedorderslink,
                    deliveredorderslink: _vm.deliveredorderslink,
                    setnotificationlink: _vm.setnotificationlink,
                    upload_files_link: _vm.upload_files_link,
                    delete_files_link: _vm.delete_files_link,
                    downloadlink: _vm.downloadlink,
                    refusebilllink: _vm.refusebilllink,
                    confirmorderlink: _vm.confirmorderlink,
                    presavedeliverylink: _vm.presavedeliverylink,
                    novaposhtacitysearchlink: _vm.novaposhtacitysearchlink,
                    novaposhtastreetsearchlink: _vm.novaposhtastreetsearchlink,
                    novaposhtawarehousessearchlink:
                      _vm.novaposhtawarehousessearchlink,
                  },
                })
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }